// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__ZVe76","imagePlaceholder":"styles_imagePlaceholder__ceMSc","shimmer":"styles_shimmer__fbhOi"};